<template>

  <div class="centerfold-slides">
    <swiper :config="swiperConfig" :slidescount="preparedLayoutSlides.length">
      <div class="swiper-slide" v-for="(page,page_i) in preparedLayoutSlides" :key="'paj23'+page_i">        
          
          <div class="page" :class="page_cls(page)">
            <div :class="{ slidefull: (page.format=='1'), slide1: (page.format=='1-1') }">

              <template v-if="page.slide1 && page.slide1.media">
                
                <div class="img" v-if="page.slide1.media && page.slide1.media.type == 'image'">
                    <img class="img" :src="mediaUrl(page.slide1.media_id,2500,undefined,true)" :alt="page.slide1.media.title">						
                </div>

                <video-embed v-if="page.slide1.media.type == 'vimeo' || page.slide1.media.type == 'youtube'" :type="page.slide1.media.type" :video_slug="page.slide1.media.video_slug" :responsiveblockmode="true" :sound="true" :controls="true" />

                <div class="generic-add-to-casting-btn" v-if="can_add_to_casting" @click="add_to_casting($event,page.slide1.media)">
                  Add to package
                </div>

              </template>

            </div>
            <div class="slide2" v-if="page.format == '1-1'" >
              
              <template v-if="page.slide2 && page.slide2.media">
                
                <div class="img" v-if="page.slide2.media && page.slide2.media.type == 'image'">
                    <img class="img" :src="mediaUrl(page.slide2.media_id,2500,undefined,true)" :alt="page.slide2.media.title">						
                </div>

                <video-embed v-if="page.slide2.media.type == 'vimeo' || page.slide2.media.type == 'youtube'" :type="page.slide2.media.type" :video_slug="page.slide2.media.video_slug" :responsiveblockmode="true" :sound="true" :controls="true" />

                <div class="generic-add-to-casting-btn" v-if="can_add_to_casting" @click="add_to_casting($event,page.slide2.media)">
                  Add to package
                </div>

              </template>

            </div>              
          </div>                  	

      </div>
    </swiper>

    <div class="blockslides">
      <template v-for="(page,page_i) in preparedLayoutSlides">
        
        <div class="slide">          
          <div class="img" v-if="page.slide1.media && page.slide1.media.type == 'image'">
              <img class="img" :src="mediaUrl(page.slide1.media_id,2500,undefined,true)" :alt="page.slide1.media.title">						
          </div>
          <video-embed v-if="page.slide1.media.type == 'vimeo' || page.slide1.media.type == 'youtube'" :type="page.slide1.media.type" :video_slug="page.slide1.media.video_slug" :responsiveblockmode="true" :sound="true" :controls="true" />
          <div class="generic-add-to-casting-btn" v-if="can_add_to_casting" @click="add_to_casting($event,page.slide1.media)">
            Add to package
          </div>
        </div>    

        <div class="slide" v-if="page.slide2">          
          <div class="img" v-if="page.slide2.media && page.slide2.media.type == 'image'">
              <img class="img" :src="mediaUrl(page.slide2.media_id,2500,undefined,true)" :alt="page.slide2.media.title">						
          </div>
          <video-embed v-if="page.slide2.media.type == 'vimeo' || page.slide2.media.type == 'youtube'" :type="page.slide2.media.type" :video_slug="page.slide2.media.video_slug" :responsiveblockmode="true" :sound="true" :controls="true" />
          <div class="generic-add-to-casting-btn" v-if="can_add_to_casting" @click="add_to_casting($event,page.slide2.media)">
            Add to package
          </div>
        </div>    
        
      </template>
    </div>

  </div>

</template>

<script>

import mixins from '.././mixins'
import Swiper from '.././components/Swiper'
import VideoEmbed from '.././components/VideoEmbed.vue'

export default {
  props: [ 'slides', 'canAddToCasting' ],
  components: {
    Swiper, VideoEmbed, 
  },
  mixins: [ mixins.generic ],
  data(){ return {
     
    swiperConfig: {

      
    },

    slides_local: [],

  }},
  computed:{

    
    can_add_to_casting(){
      // only AM available for now, only needed there :)
      if( !this.is_site_am ) return false
      
      if( this.canAddToCasting ) return true
      return false
    },

    
    preparedLayoutSlides(){
      
      var output = []

			for( var i = 0; i < this.slides_local.length; i++ ) {
				var slide = this.slides_local[i]
				
				if( slide.landscape ) {
					output.push({
						format: '1',
						slide1: slide,
					})
					continue
				}
				
				var lastSlide = output[ output.length - 1 ]

				if( lastSlide && lastSlide.format == '1-1' && !lastSlide.slide2 ) {
					output[ output.length - 1 ].slide2 = slide
					continue
				}

				output.push({
					format: '1-1',
					slide1: slide,
				})
				
			}

			return output
    },
   

    
  },
  methods: {
    
    page_cls(page){
      var cls = {}
      cls[ 'format-' + page.format ] = true
      return cls
    },

    add_to_casting( event, media ){
      
      // only AM available for now, only needed there :)
      if( !this.is_site_am ) return
      if( !media ) return

      this.modal_open({ modal:'am_add_casting_by_artist', media })

      return

      // get related artists, so we can know for which we want to add 
      
      var item = {}
      
      item.media_id = media.id

      if( this.is_site_am && this.loaded_artist ) item.artist_id = 1 // hardcoded
      //if( this.is_site_am && this.loaded_artist ) item.artist_id = this.loaded_artist.id
      
      this.casting_item_add(item)

      // visual feedback
      var origtext = event.target.innerHTML
      event.target.innerHTML = '· · ·'

      setTimeout(function(){
        event.target.innerHTML = 'Added'
      }, 250)
      
      setTimeout(function(){
        event.target.innerHTML = origtext
      }, 1000)

      setTimeout(()=>{ document.querySelector('.package-minimenu').classList.add('lookatme') },100)
      setTimeout(()=>{ document.querySelector('.package-minimenu').classList.remove('lookatme') },1200)
      
      eventBus.$emit('active_casting_save_to_cloud')

    },
    
  },  
  
  created(){
    
    if( this.slides && this.slides.length ) this.slides_local = this.slides

  },

  mounted(){
    
    
    
  },

  destroyed(){
    
    

  },

}
</script>


// WEBPACK FOOTER //
// src/components/CenterfoldSlides.vue